<template>
	<!-- CART DROPDOWN -->
	<vs-dropdown vs-custom-content class="cursor-pointer" v-if="defaultGroupTracking.id">
		<div class="flex items-center justify-start cursor-pointer" style="color: #8d8d8d">
			<feather-icon icon="UsersIcon" class="cursor-pointer ml-4 mr-1 mt-1" />
			<span class="font-bold">{{ defaultGroupTracking.name.toLowerCase() | capitalize }}</span>
		</div>

		<vs-dropdown-menu class="cart-dropdown vx-navbar-dropdown" :class="{'dropdown-custom': groups.length}">
			<!-- IF CART HAVE ITEMS: HEADER -->
			<template v-if="groups.length">
				<div class="notification-header text-center p-5 bg-primary text-white">
					<h3 class="text-white">
						{{ groups.length }} {{ $t("Groups.Group") }}<span v-show="groups.length > 1">s</span>
					</h3>
					<p class="opacity-75">{{ $t("Groups.AvailableGroups") }}</p>
				</div>

				<!-- CART ITEMS -->
				<component
					:is="scrollbarTag"
					ref="mainSidebarPs"
					class="scroll-area--cart-items-dropdowm p-0 mb-10"
					:settings="settings"
					:key="$vs.rtl"
				>
					<ul class="bordered-items">
						<li
							v-for="item in groups"
							:key="item.objectID"
							class="vx-row no-gutter cart-item cursor-pointer hover:shadow-md"
							:class="[{'bg-primary-gradient text-white': defaultGroupTracking.id === item.id}]"
							@click="markAsFavorite(item)"
						>
							<!-- IMG COL -->
							<div class="vx-col w-1/5 item-img-container flex items-center justify-center">
								<vs-avatar
									class="g-label text-xl"
									badge
									size="large"
									:text="item.name"
									:color="defaultGroupTracking.id === item.id ? 'white' : 'primary'"
									:text-color="defaultGroupTracking.id === item.id ? 'primary' : 'rgb(246, 190, 16)'"
								/>
							</div>
							<!-- INFO COL -->
							<div class="vx-col w-4/5 pr-4 pl-2 py-4 flex flex-col justify-center">
								<span class="font-medium block cart-item-title truncate">{{ item.name }}</span>
								<small class="truncate mb-2">{{ item.description }}</small>
								<div class="flex items-center justify-between">
									<span class="text-sm font-medium"
										>{{ $t("Resource.Resources") }} <small>x</small> {{ item.total_resource }}</span
									>
									<feather-icon
										icon="StarIcon"
										svgClasses="h-4 w-4"
										class="text-yellow"
										:title="$t('Groups.Favorite')"
										v-if="defaultGroupTracking.id === item.id"
									/>
								</div>
							</div>
						</li>
					</ul>
				</component>
				<div
					class="
						checkout-footer
						fixed
						bottom-0
						rounded-b-lg
						text-primary
						font-semibold
						w-full
						p-2
						text-center
						border border-b-0 border-l-0 border-r-0 border-solid
						d-theme-border-grey-light
						cursor-pointer
					"
					@click="openConfirmRemove"
				>
					<span class="flex items-center justify-center hover:text-danger">
						<feather-icon icon="XIcon" svgClasses="h-4 w-4" />
						<span class="ml-2">{{ $t("Remove") }}</span>
					</span>
				</div>
			</template>
		</vs-dropdown-menu>
	</vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moduleGroup from "@/store/group/moduleGroup.js";
import Group from "@/models/Group.js";

export default {
	components: {
		VuePerfectScrollbar,
	},
	data() {
		return {
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			favoriteGroup: new Group({}),
		};
	},
	computed: {
		// CART DROPDOWN
		groups() {
			return this.$store.state.moduleGroup.groups;
		},
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
		resources() {
			return this.$store.getters["chat/contacts"];
		},
		defaultGroupTracking() {
			return this.$store.state.modulePreferences.default_group_tracking;
		},
	},
	methods: {
		markAsFavorite(item) {
			this.favoriteGroup = new Group(item);
			this.$store.commit("moduleGroup/SET_SELECTED_GROUP", this.favoriteGroup);
			this.updateGroupOnPreferences();
		},
		openConfirmRemove() {
			this.$vs.dialog({
				type: "confirm",
				color: "primary",
				title: this.$t("Remove") + " " + this.$t("Groups.DefaultGroup"),
				text: this.$t("Groups.FavoriteRemoveConfirmText") + ` ` + this.$t("TextAccepContinue"),
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
				accept: this.deleteFavorite,
			});
		},
		async deleteFavorite() {
			try {
				await this.$store.dispatch("modulePreferences/updatePreferences", {
					default_group_tracking: new Group({}),
					show_default_group_tracking: false,
				});
			} catch (error) {}
		},
		async updateGroupOnPreferences() {
			if (this.favoriteGroup.id) {
				try {
					await this.$store.dispatch("modulePreferences/updatePreferences", {
						default_group_tracking: this.favoriteGroup,
					});
				} catch (error) {}
			}
		},
	},
	created() {
		if (!moduleGroup.isRegistered) {
			this.$store.registerModule("moduleGroup", moduleGroup);
			moduleGroup.isRegistered = true;
		}

		this.favoriteGroup = this.defaultGroupTracking;
	},
};
</script>
